import { AppointmentsModel } from "types/generated/models";
import { useGetQuery } from "hooks/useClientPortalQuery";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";

export interface IUseAppointmentsHook {
    data?: AppointmentsModel | null;
    isLoading: boolean;
    refetch?: (options?: RefetchOptions) => Promise<QueryObserverResult<AppointmentsModel, Error>>;
}

export function getAppointmentsQueryUrl(clientPortalGuid: string) {
    return `/api/v1/${clientPortalGuid}/Appointments/GetAppointmentsModel`;
}

export function useAppointments(): IUseAppointmentsHook {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { data, isLoading, refetch } = useGetQuery<AppointmentsModel>({
        url: getAppointmentsQueryUrl(clientPortalGuid),
    });

    return {
        data: data,
        isLoading,
        refetch,
    };
}
